(function () {
  function init() {
    const productJsonEl = document.getElementById('product-json');
    if (!productJsonEl) return;

    let product;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (e) { return; }

    const colorOptionNames = ['couleur', 'color', 'colour'];
    let colorOptionIndex = -1;
    product.options.forEach(function (opt, i) {
      if (colorOptionNames.includes(opt.toLowerCase())) colorOptionIndex = i;
    });

    if (colorOptionIndex === -1) return;

    const knownColors = [];
    product.variants.forEach(function (v) {
      const color = v.options[colorOptionIndex].toLowerCase().trim();
      if (!knownColors.includes(color)) knownColors.push(color);
    });

    const variantColorMap = {};
    product.variants.forEach(function (v) {
      variantColorMap[v.id] = v.options[colorOptionIndex];
    });

    function filterByColor(colorValue) {
      const list = document.querySelector('.product__media-list');
      if (!list) return;

      list.querySelectorAll('li').forEach(function (item) {
        const img = item.querySelector('img');
        if (!img) { item.style.display = ''; return; }

        const alt = (img.getAttribute('alt') || '').toLowerCase().trim();

        if (!knownColors.includes(alt)) { item.style.display = ''; return; }

        item.style.display = (!colorValue || alt === colorValue.toLowerCase().trim()) ? '' : 'none';
      });
    }

    function applyFromVariantId(variantId) {
      const color = variantColorMap[parseInt(variantId)];
      if (color) filterByColor(color);
    }

    document.addEventListener('variant:changed', function (e) {
      const variantId = e.detail && e.detail.variant && e.detail.variant.id;
      if (variantId) applyFromVariantId(variantId);
    });

    document.querySelectorAll('[name="id"]').forEach(function (el) {
      el.addEventListener('change', function () {
        applyFromVariantId(this.value);
      });
    });

    const initialInput = document.querySelector('[name="id"]');
    if (initialInput) applyFromVariantId(initialInput.value);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();